<template>
  <b-container fluid style="padding-top: 10px">
    <vue-good-table
        ref="News"
        v-if="true"
        :columns="userListColumns"
        :rows="userListRows"
        :totalRows="totalRecords"
        :group-options="{
           enabled: true,
           headerPosition: 'top',
           collapsable: 7,
           rowKey: 'userId'
        }"
        styleClass="vgt-table condensed table-bordered table-striped"
        @on-row-click="onRowClick"
        :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 50,
                    position: 'top',
                    perPageDropdown: [25, 50, 100, 500],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                }">
      <template slot="table-actions">
        <b-button size="sm" :disabled="isDownloading" @click="requestDownload()">
          {{ isDownloading ? 'Downloading...' : 'Export Full User Details List' }}
        </b-button>
      </template>
      <template slot="table-header-row" slot-scope="props">
        <b-row style="float: right; width: 100%">
          <b-col cols="4">
            <span style="text-align: center">
                    {{ props.row.label + " (" + props.row.userId + ")" }}
           </span>
          </b-col>
          <b-col cols="4">
            <div style="text-align: start; padding-left: 5px">
                <span>
                   Last Login: {{ toLocaleDateString(props.row.lastLoginDate) }}
                </span>
            </div>
          </b-col>
          <b-col cols="3">
            <div style=" text-align: center">
                <span style="text-align: center">
                    <b-button size="sm"
                              @click="resetPassword(props.row.userId)">
                            Reset Password
                    </b-button>
                </span>
            </div>
          </b-col>
          <b-col cols="1">
            <div style="text-align: center">
                <span>
                    <b-button size="sm"
                              @click="disableAccount(props.row.userId,props.row.enabled)">
                            {{ props.row.enabled ? 'Disable' : 'Enable' }}
                    </b-button>
                </span>
            </div>
          </b-col>
        </b-row>
      </template>
      <template slot="table-row" slot-scope="props">
            <span v-if="props.column.label === 'User Name'">
                  {{ props.formattedRow[props.column.field] }}
            </span>
        <span v-else>
                    {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </b-container>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import Swal from "sweetalert2";
import {FileUtils} from "@/lib/FileUtils";

export default {
  name: "LoginAdmin",
  components: {
    Datepicker,
    VueGoodTable
  },
  data() {
    return {
      userListColumns: [
        {
          label: "User Name",
          field: "userName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'User Name', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "First Name",
          field: "firstName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'First Name', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Last Name",
          field: "lastName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Last Name', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Email",
          field: "email",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Email', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Group",
          field: "groupName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Email', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Roles",
          field: "roles",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Email', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Telephone",
          field: "telephoneNumber",
        },
        {
          label: "id",
          field: "userId",
          hidden: true
        }],
      items: [],
      rows: [],
      userListRows: [],
      totalRecords: 0,
      isDownloading: false,
      certificationDate: '',
      surveyToCertify: '',
      groupIdToCertify: ''
    }
  },
  mounted() {
    this.loadUserList(this);
  },
  methods: {
    toLocaleDateString: function (value) {
      if (value === "" || value === null) {
        return "Unknown";
      }
      let date = new Date(0);
      date.setUTCMilliseconds(value);

      let options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      };
      return date.toLocaleDateString("en-US", options)
    },
    loadUserList: function () {
      this.$http.get("account/users/meta")
          .then(result => {
            this.userListRows = result.data.rows;
            this.totalRecords = result.data.total;
          })
          .catch(error => {
            console.log("The error: " + error);
          })
    },
    onRowClick(params) {
      console.log("The item: ");
      console.log(params);
      let row = params.row;
      this.$router.push({name: 'Update User', params: {userId: row.userId}});
      ;
    },
    resetPassword: function (userId) {
      let self = this;
      this.$http.post(`admin/${userId}/reset`)
          .then(result => {
            let disableResult = result.data;
            if (disableResult.result === "SUCCESSFUL") {
              Swal.fire({
                title: 'User Account Password Reset Email Sent',
                text: 'User Will Be Sent A Password Reset Link.',
                icon: 'success'
              });
              self.loadUserList();
            } else {
              Swal.fire({
                title: 'User Account Password Reset Failed',
                text: `Unable to reset the password for this account!`,
                icon: 'error'
              });
            }
          })
          .catch(error => {
            Swal.fire({
              title: 'Error Attempting to Reset Password',
              text: `Error: ${error}`,
              icon: 'error'
            });
          })
    },
    disableAccount: function (userId, accountStatus) {
      let self = this;
      console.log(`Account Status: ${accountStatus}`);
      let accountAction = accountStatus ? 'disable' : 'enable'
      let title = `User account is now ${accountAction}d`;
      this.$http.post(`admin/${userId}/status/${accountAction}`)
          .then(result => {
            let disableResult = result.data;
            if (disableResult === "SUCCESSFUL") {
              Swal.fire({
                title: title,
                text: 'This account has been updated',
                icon: 'success'
              });
              self.loadUserList();
            } else {
              Swal.fire({
                title: `Account ${accountAction} Failed`,
                text: `Unable to ${accountAction} this account!`,
                icon: 'error'
              });
            }
          })
          .catch(error => {
            Swal.fire({
              title: 'Error Attempting to Reset Password',
              text: `Error: ${error}`,
              icon: 'error'
            });
          })
    },
    dismissTheModal: function () {
      this.$bvModal.hide("modal-1");
      this.surveyToCertify = '';
      this.groupIdToCertify = '';
      this.certificationDate = '';
    },
    requestDownload() {
      if (this.isDownloading) {
        return;
      }
      this.isDownloading = true;
      this.$toasted.show('Download requested... Please wait.', {
        containerClass: 'super-toasty',
        iconPack: 'fontawesome',
        closeOnSwipe: true,
        action: {
          text: 'DISMISS',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          }
        },
        icon: {
          name: 'fa-download',
          after: false,
        }
      }).goAway(5000);

      this.$http.get(`account/download/users`, {responseType: "blob"})
          .then(response => {
            FileUtils.saveExcelToDisk(response);
          })
          .finally(() => {
            this.isDownloading = false;
          });
    },
  }
}
</script>
